// Self-registering plugin for the merchant AI Agent feature: registers the
// "AI Agent" settings page and the "使用指南" (usage guide) page as routes
// mounted inside the dashboard shell. Menu entries are added in the sidebar
// (FORK_PATCH). Admin-only access is enforced via route meta permissions.
// Called once from `app/javascript/entrypoints/dashboard.js`.
import AiAgentSettingsPage from './components/AiAgentSettingsPage.vue';
import UsageGuidePage from './components/UsageGuidePage.vue';
import AiUsagePage from './components/AiUsagePage.vue';
// Agent reply assistant (in-conversation streaming draft).
import aiAssistModule from './ai_assist/store';
import inboxAutoReplyModule from './inboxAutoReplyStore';
import AiAssistHeaderToggle from './ai_assist/components/AiAssistHeaderToggle.vue';
import AiAssistStatusBar from './ai_assist/components/AiAssistStatusBar.vue';
import AiAssistBottomPanel from './ai_assist/components/AiAssistBottomPanel.vue';

export const AI_AGENT_SETTINGS_ROUTE = 'custom_ai_agent_settings';
export const USAGE_GUIDE_ROUTE = 'custom_usage_guide';
export const AI_USAGE_ROUTE = 'custom_ai_usage';

const addRoute = (router, route) => {
  if (router.hasRoute(route.name)) return;
  if (router.hasRoute('app_container')) {
    router.addRoute('app_container', route);
  } else {
    router.addRoute(route);
  }
};

export const installAiAgent = ({ app, store, router }) => {
  // Register the agent reply assistant: Vuex module + globally-available header
  // toggle and status bar components (mounted by ConversationHeader / ReplyBox).
  if (store && !store.hasModule('aiAssistFeature')) {
    store.registerModule('aiAssistFeature', aiAssistModule);
  }
  if (store && !store.hasModule('agentInboxAutoReply')) {
    store.registerModule('agentInboxAutoReply', inboxAutoReplyModule);
  }
  if (app) {
    app.component('AiAssistHeaderToggle', AiAssistHeaderToggle);
    app.component('AiAssistStatusBar', AiAssistStatusBar);
    app.component('AiAssistBottomPanel', AiAssistBottomPanel);
  }

  if (!router) return;

  addRoute(router, {
    name: AI_AGENT_SETTINGS_ROUTE,
    path: '/app/accounts/:accountId/custom/ai-agent',
    component: AiAgentSettingsPage,
    meta: { permissions: ['administrator'] },
  });

  addRoute(router, {
    name: USAGE_GUIDE_ROUTE,
    path: '/app/accounts/:accountId/custom/usage-guide',
    component: UsageGuidePage,
    meta: { permissions: ['administrator'] },
  });

  // AI token usage report (AI Agent + Translation), reached via Reports menu.
  addRoute(router, {
    name: AI_USAGE_ROUTE,
    path: '/app/accounts/:accountId/custom/ai-usage',
    component: AiUsagePage,
    meta: { permissions: ['administrator'] },
  });
};

export default installAiAgent;
